import Resizer from 'react-image-file-resizer';

export const resizeImage = (file, type = 'blob') => new Promise(resolve => {
    Resizer.imageFileResizer(file, 1024, 1024, 'JPEG', 100, 0,
        uri => {
            resolve(uri);
        },
        type
    );
});